/** Espelho de api/utils/subsidioCapabilities.js para o frontend. */

const UNIDADES_MODOS = ["MEXICO", "MELIBRASIL"];
const CONTRATO_TARIFA_MODOS = ["FRIBURGO", "MEXICO", "MELIBRASIL"];

export function normalizeModoSubsidio(modo) {
  let m = (modo || "").toUpperCase();
  if (m === "MELI") m = "MEXICO";
  return m;
}

/** Ciclo de pagamento só México/MeliBrasil. Friburgo permanece mês calendário. */
export function modoSuportaCicloPagamento(modo) {
  return UNIDADES_MODOS.indexOf(normalizeModoSubsidio(modo)) !== -1;
}

export function capabilitiesFromModo(modo) {
  const m = normalizeModoSubsidio(modo);
  return {
    has_subsidio_contrato_rio: m === "RIO" ? 1 : 0,
    has_subsidio_contrato_tarifa: CONTRATO_TARIFA_MODOS.indexOf(m) !== -1 ? 1 : 0,
    has_subsidio_contrato_unidades:
      UNIDADES_MODOS.indexOf(m) !== -1 ? 1 : 0,
    has_subsidio_scorecard_melibrasil: m === "MELIBRASIL" ? 1 : 0,
  };
}

export function mergeSetupCapabilities(row) {
  if (!row || typeof row !== "object") return {};
  const fromModo = capabilitiesFromModo(row.modo_subsidio);
  const merged = { ...row };
  Object.keys(fromModo).forEach((key) => {
    if (merged[key] == null) merged[key] = fromModo[key];
  });
  return merged;
}

export function hasSubsidioCapability(setup, capName) {
  if (!setup || !capName) return false;
  const v = setup[capName];
  return v === 1 || v === "1" || v === true;
}

export function isModoSubsidioMexico(setup) {
  if (!setup) return false;
  const m = (setup.modo_subsidio || "").toUpperCase();
  if (m === "MEXICO" || m === "MELI") return true;
  return (
    hasSubsidioCapability(setup, "has_subsidio_contrato_tarifa") &&
    hasSubsidioCapability(setup, "has_subsidio_contrato_unidades") &&
    !hasSubsidioCapability(setup, "has_subsidio_contrato_rio")
  );
}
